"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAge = validateAge;
exports.requiredError = requiredError;
exports.minError = minError;
exports.maxError = maxError;
exports.validatePassword = exports.validateEmail = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateAge(birthday, showFallback) {
  var dob = (0, _moment.default)(birthday, showFallback ? "DD/MM/YYYY" : "YYYY-MM-DD");
  var now = (0, _moment.default)();
  var difference = now.diff(dob, "year", true);
  return isNaN(difference) ? undefined : difference >= 18 && difference < 120;
}

function requiredError(field) {
  var errorText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "is required";
  return "".concat(field, " ").concat(errorText);
}

function minError(field, length) {
  var errorText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "must be at least";
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "characters";
  return "".concat(errorText, " ").concat(length, " ").concat(type);
}

function maxError(field, length) {
  var errorText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "must be at most";
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "characters";
  return "".concat(errorText, " ").concat(length, " ").concat(type);
}

var validateEmail = function validateEmail(email) {
  var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return re.test(email);
};

exports.validateEmail = validateEmail;

var validatePassword = function validatePassword(password) {
  var re2 = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/;
  return re2.test(password);
};

exports.validatePassword = validatePassword;